module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADkSURBVEiJ7dTBTcNAEIXhf0KaCOLgEmghRxQhpYRQQSjBHVCCXQLSYuWYFijBh9i+pgHncYjEwfEGL5oLIu84I71PWq0GbvkTUfvxpm6Xje66aqOu2qT0zS5KmpADr6jfDyG1YY1UIBUp0AXCbF4CNZANIbt/fkdWnsXpkI0N1e0y1O+BDKixu6UtnurvfVMVmM6A2YstVmUy4g1FEU/oKuIF/Yh4QPMpyOSIIyc+h2O/5xJHZEt7WKUhHsBVxAuIIp7AKOINwNjvUr+NAm1YQxoQjZqQR099E3Idqsdfl9/yf/IF5A/njqE7lwsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/image/next.png
// module id = BAjF
// module chunks = 29